import React from "react";
import SelectImage from "./Components/SelectImage";
import ProductSection from "./Components/ProductSection";

import Priceinput from "./Components/PriceInput";
import StockBalance from "./Components/StockBalance";
import CartonDescription from "./Components/CartDescription";
import ProductDescription from "./Components/ProductDescription";
import SellingInfo from "./Components/SellingInfo";

import { Box, Checkbox, FormControl } from "@mui/material";
import { Check, ChevronDown, Plus } from "lucide-react";
import { Outlet } from "react-router-dom";

const SellAsViewScreen = () => {
  return (
    <div className="bg-white h-[100vh] overflow-y-hidden box-border">
      <Outlet />
    </div>
  );
};

export default SellAsViewScreen;
